/* SafetyClip effecten: reveal, stappen-scroll, kleurenrad, zaklamp, zwevende clips */
(function () {
  if (window.__scfx) return; window.__scfx = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KL = [['groen', '#4CAF3E'], ['blauw', '#1B7FD4'], ['rood', '#E02020'], ['zwart', '#14161A'], ['oranje', '#F07C1B'], ['paars', '#8E3FBF'], ['roze', '#F58DA0']];
  var CLIP_SVG = '<path d="M120 22a98 98 0 1 1 0 196a98 98 0 0 1 0-196zM120 80a40 40 0 0 0 0 80l86-14a98 98 0 0 0 0-52z" fill="currentColor" fill-rule="evenodd"/><rect x="6" y="104" width="28" height="32" rx="6" fill="currentColor"/><path d="M12 110h16M12 116h16M12 122h16M12 128h16" stroke="rgba(0,0,0,.35)" stroke-width="2"/>';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function reveal() {
    var els = $$('.scx-rv');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -10% 0px', threshold: .1 });
    els.forEach(function (e) { io.observe(e); });
  }

  function floats() {
    $$('.scx-float').forEach(function (box) {
      var n = parseInt(box.dataset.n || '8', 10), col = box.dataset.color;
      for (var i = 0; i < n; i++) {
        var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        s.setAttribute('viewBox', '0 0 240 240'); var sz = 80 + Math.random() * 220;
        s.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (Math.random() * 100) + '%;top:' + (Math.random() * 100) + '%;color:' + (col || KL[i % 7][1]) + ';animation-duration:' + (20 + Math.random() * 30) + 's;animation-direction:' + (i % 2 ? 'reverse' : 'normal');
        s.innerHTML = CLIP_SVG; box.appendChild(s);
      }
    });
  }

  /* Stappen: 1 blikje open, 2 clip zakt op de rand, 3 halve slag dicht. */
  function steps() {
    $$('.scx-steps').forEach(function (sec) {
      var clipEl = $('[data-sc-clip3d]', sec), items = $$('.scx-step', sec);
      function tick() {
        var api = clipEl && clipEl.scClip; if (!api) return;
        var vh = innerHeight, mid = vh * .5, cur = 0, best = 1e9;
        items.forEach(function (it, i) { var r = it.getBoundingClientRect(); var d = Math.abs(r.top + r.height / 2 - mid); if (d < best) { best = d; cur = i; } });
        items.forEach(function (it, i) { it.classList.toggle('is-on', i === cur); });
        var r0 = items[0].getBoundingClientRect(), rl = items[items.length - 1].getBoundingClientRect();
        var p = clamp((mid - (r0.top + r0.height / 2)) / ((rl.top + rl.height / 2) - (r0.top + r0.height / 2)), 0, 1);
        var lift = clamp((.50 - p) / .28, 0, 1);
        var e = lift * lift * (3 - 2 * lift);
        var turn = clamp((p - .62) / .30, 0, 1);
        api.setLift(e); api.setTilt(e * .30);
        api.setTurn(turn * turn * (3 - 2 * turn) * 180); api.setAuto(false);
      }
      document.addEventListener('scroll', tick, { capture: true, passive: true }); addEventListener('resize', tick); tick();
      var iv = setInterval(function () { if (clipEl && clipEl.scClip) { tick(); clearInterval(iv); } }, 200);
    });
  }

  /* Blikjesmaten: knoppen die het 3D-blikje van formaat laten wisselen. */
  function maten() {
    $$('.scx-maten').forEach(function (sec) {
      var clipEl = $('[data-sc-clip3d]', sec), knoppen = $$('.scx-maat', sec);
      knoppen.forEach(function (b) {
        b.addEventListener('click', function () {
          knoppen.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          if (clipEl && clipEl.scClip) clipEl.scClip.setSize(b.dataset.maat);
        });
      });
    });
  }

  function rad() {
    $$('.scx-rad').forEach(function (sec) {
      var wiel = $('.scx-rad__wiel', sec), naam = $('.scx-rad__naam', sec), zin = $('.scx-rad__zin', sec), koop = $('.scx-rad__koop', sec), clipEl = $('[data-sc-clip3d]', sec);
      var namen = JSON.parse(sec.dataset.namen || '{}'), zinnen = JSON.parse(sec.dataset.zinnen || '{}'), urls = JSON.parse(sec.dataset.urls || '{}'), imgs = JSON.parse(sec.dataset.imgs || '{}');
      var N = KL.length, STEP = 360 / N, bliks = [];
      KL.forEach(function (k, i) {
        var d = document.createElement('div'); d.className = 'scx-rad__blik'; d.style.setProperty('--a', (i * STEP) + 'deg');
        d.innerHTML = '<img src="' + imgs[k[0]] + '" alt="SafetyClip ' + (namen[k[0]] || k[0]) + '" draggable="false" loading="lazy">'; wiel.appendChild(d); bliks.push(d);
        var s = document.createElement('span'); s.textContent = namen[k[0]] || k[0]; naam.appendChild(s);
      });
      var rot = 0, vel = 0, dragging = false, lastA = 0, lastT = 0, cur = -1;
      function cx() { var b = wiel.getBoundingClientRect(); return [b.left + b.width / 2, b.top + b.height / 2]; }
      function angleAt(e) { var c = cx(); return Math.atan2(e.clientY - c[1], e.clientX - c[0]) * 180 / Math.PI; }
      function show() {
        wiel.style.setProperty('--rot', rot + 'deg');
        var idx = Math.round(-rot / STEP) % N; if (idx < 0) idx += N;
        if (idx !== cur) {
          cur = idx; var k = KL[idx]; sec.style.setProperty('--k', k[1]); if (zin) zin.textContent = zinnen[k[0]] || '';
          $$('span', naam).forEach(function (s, i) { s.classList.toggle('aan', i === idx); }); bliks.forEach(function (b, i) { b.classList.toggle('aan', i === idx); });
          sec.classList.toggle('donker', idx === 3);
          var w = $('.scx-rad__wijzer svg', sec); if (w) w.style.color = idx === 3 ? '#FAF8F3' : '#16181D';
          if (koop && urls[k[0]]) koop.href = urls[k[0]];
          if (clipEl && clipEl.scClip) clipEl.scClip.setColor(k[1]);
        }
      }
      function snap() { return Math.round(rot / STEP) * STEP; }
      wiel.addEventListener('pointerdown', function (e) { dragging = true; vel = 0; lastA = angleAt(e); lastT = performance.now(); wiel.setPointerCapture(e.pointerId); });
      wiel.addEventListener('pointermove', function (e) { if (!dragging) return; var a = angleAt(e), d = a - lastA; if (d > 180) d -= 360; if (d < -180) d += 360; rot += d; var now = performance.now(); vel = d / Math.max(1, now - lastT) * 16; lastA = a; lastT = now; show(); });
      var stop = function () { dragging = false; }; wiel.addEventListener('pointerup', stop); wiel.addEventListener('pointercancel', stop);
      var l = $('.scx-rad__knoppen .l', sec), r = $('.scx-rad__knoppen .r', sec);
      if (l) l.onclick = function () { rot = snap() + STEP; vel = 0; };
      if (r) r.onclick = function () { rot = snap() - STEP; vel = 0; };
      function loop() { if (!dragging) { if (Math.abs(vel) > .05) { rot += vel; vel *= .94; } else { rot += (snap() - rot) * .12; } show(); } requestAnimationFrame(loop); }
      function wij() { var b0 = bliks[0].getBoundingClientRect(), rs = sec.getBoundingClientRect(), w = wiel.getBoundingClientRect(); var cy = w.top + w.height / 2; var rr = Math.hypot(b0.left + b0.width / 2 - (w.left + w.width / 2), b0.top + b0.height / 2 - cy); sec.style.setProperty('--wb', (rs.bottom - (cy - rr - b0.height / 2) + 14) + 'px'); }
      addEventListener('resize', wij); show(); wij(); setTimeout(wij, 400);
      var iv = setInterval(function () { if (clipEl && clipEl.scClip) { clipEl.scClip.setColor(KL[cur][1]); clearInterval(iv); } }, 200);
      if (reduce) show(); else requestAnimationFrame(loop);
    });
  }

  function lamp() {
    if (reduce) return;
    $$('.scx-lamp').forEach(function (sec) {
      var licht = $('.scx-lamp__licht', sec), cur = $('.scx-lamp__cur', sec);
      var lx = -500, ly = -500, tx = -500, ty = -500, ang = 0, auto = true, R = 200, t0 = performance.now();
      function setR() { R = Math.max(150, Math.min(260, innerWidth * .16)); } setR(); addEventListener('resize', setR);
      sec.addEventListener('pointermove', function (e) { var b = sec.getBoundingClientRect(); tx = e.clientX - b.left; ty = e.clientY - b.top; auto = false; });
      sec.addEventListener('pointerleave', function () { auto = true; });
      var visible = true; if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(sec);
      function loop(now) {
        if (visible) {
          if (auto) { var b = sec.getBoundingClientRect(), s = (now - t0) / 1000; tx = b.width / 2 + Math.cos(s * .7) * b.width * .32; ty = b.height / 2 + Math.sin(s * 1.1) * b.height * .28; }
          var dx = tx - lx, dy = ty - ly; lx += dx * .14; ly += dy * .14; if (Math.hypot(dx, dy) > .5) ang = Math.atan2(dy, dx) * 180 / Math.PI;
          licht.style.clipPath = 'circle(' + R + 'px at ' + lx + 'px ' + ly + 'px)';
          if (cur) { cur.style.left = lx + 'px'; cur.style.top = ly + 'px'; cur.style.transform = 'translate(-50%,-50%) rotate(' + ang + 'deg)'; }
        }
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);
    });
  }

  function run() { reveal(); floats(); steps(); maten(); rad(); lamp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
